'use strict';


let leftMenu = new createSwiper('.menu-slider > .swiper-container');
let bannersSlider = new createSwiper('.banners-slider > .swiper-container');

